import { platformBrowser } from '@angular/platform-browser';
import { AppModule } from './app/app-module';
import * as moment from 'moment';
import 'moment/locale/tr';
import 'moment/locale/en-gb';
moment.locale('tr');

platformBrowser().bootstrapModule(AppModule, {
  ngZoneEventCoalescing: true,
})
  .catch(err => console.error(err));
